import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import "./ModalPopup.css"

function ModalPopup(props) {
    return (
        <>
            <Modal centered show={props.show}>
                <Modal.Body >
                    <b>Are you sure you want to submit the requested source URL? This will replace old source URL with the new one. </b>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={props.close}>
                        Close
                    </Button>
                    <Button variant="warning" onClick={props.submit}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default ModalPopup;